import React from 'react'
import '../../styles/tickets-mobile.css'

const TABS = [
  { id: 'inbox', label: 'Inbox' },
  { id: 'conversation', label: 'Conversation' },
  { id: 'context', label: 'Context' }
]

function EmptyState({ children }) {
  return (
    <div className="mob-empty">
      <div className="mob-empty-glyph" aria-hidden>👤</div>
      <div className="mob-empty-h">No ticket open</div>
      <div className="mob-empty-p">{children}</div>
    </div>
  )
}

/**
 * Phone layout: a single full-screen body for one of three tabs, with a
 * persistent bottom tab bar for nav. The orchestrator owns the actual
 * Inbox / Conversation / Context view nodes — this layout only decides
 * which one is on screen, and the orchestrator drives that decision via
 * `tab` + `setTab` props.
 *
 * Controlled-only: the auto-switch on ticket selection lives in the
 * orchestrator's selectTicket so re-tapping the already-selected ticket
 * still switches to Conversation (an internal useEffect on
 * `activeTicketId` bailed when the id didn't change).
 *
 * `hideTabs` collapses the bottom bar — used when the composer is
 * expanded or bulk-edit mode wants the screen.
 */
function MobileTicketsLayout({
  inbox, conversation, context,
  hasSelectedTicket = false,
  tab,
  setTab,
  hideTabs = false
}) {
  let body
  if (tab === 'inbox') {
    body = inbox
  } else if (tab === 'conversation') {
    body = hasSelectedTicket ? conversation : (
      <EmptyState>Open a ticket from your inbox to read &amp; reply.</EmptyState>
    )
  } else {
    body = hasSelectedTicket ? context : (
      <EmptyState>Open a ticket to see customer history, linked items and notes.</EmptyState>
    )
  }

  return (
    <div className="mob-layout">
      <div className="mob-body">{body}</div>
      {!hideTabs && (
        <nav className="mob-tabs" role="tablist" aria-label="Tickets navigation">
          {TABS.map(t => {
            const disabled = t.id !== 'inbox' && !hasSelectedTicket
            return (
              <button
                key={t.id}
                role="tab"
                aria-selected={tab === t.id}
                aria-disabled={disabled}
                onClick={() => setTab(t.id)}
                className={`mob-tab ${tab === t.id ? 'mob-tab--active' : ''} ${disabled ? 'mob-tab--disabled' : ''}`}
              >
                <span className="mob-tab-ico" aria-hidden />
                {t.label}
              </button>
            )
          })}
        </nav>
      )}
    </div>
  )
}

export default MobileTicketsLayout
